import * as React from 'react'
import { PromoPopups } from './client-popups'

const FreebiesPopup = React.lazy(() =>
  import('./types/freebies-popup').then(m => ({ default: m.FreebiesPopup })),
)

const FavoritePopup = React.lazy(() =>
  import('./types/favorite-popup').then(m => ({ default: m.FavoritePopup })),
)

export function Popups() {
  return (
    <>
      <React.Suspense fallback={null}>
        <FreebiesPopup />
        <PromoPopups />
        <FavoritePopup />
      </React.Suspense>
    </>
  )
}
